export class MemberAd {
    constructor() {
        this.imageUrl = "";
    }
    memberName: string;
    memberCompany: string;
    adId: number;
    imageUrl: string;
    imageId: string;
    submissionDate: Date;
    memberNotes: string;
    url: string;
    runDate: string;
    numberOfSubmissions: number | null;
    mostRecentSubmission: Date | null;
    approverNotes: string;
    type: string;
    status: number;
    isClosed: boolean;
    statusString: string;
}